export default __webpack_public_path__ + "static/media/Girdle of the Berserker's Fury.e89f2890.jpg";